import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { useT } from "../../i18n/I18nProvider";

const SASHA_IMG =
  "https://customer-assets.emergentagent.com/job_digital-sculptors/artifacts/4jex31nn_Screenshot%202026-04-24%20131301.png";
const RICCARDO_IMG =
  "https://customer-assets.emergentagent.com/job_digital-sculptors/artifacts/u4syixsk_WhatsApp%20Image%202026-04-24%20at%2013.11.34.jpeg";

const FOUNDERS = [
  { img: RICCARDO_IMG, name: "Riccardo" },
  { img: SASHA_IMG, name: "Sasha" },
];

export const HomeStudio = () => {
  const t = useT();

  return (
    <section
      className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-20 md:py-40"
      data-testid="home-studio"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="overline mb-4 md:mb-5">
              {t("home.studio.overline")}
            </div>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tightest">
              <span className="font-editorial text-ink-700">
                {t("home.studio.titleRiccardo")}
              </span>
              <br /> {t("home.studio.titleAmp")}{" "}
              <span className="font-editorial text-ink-700">
                {t("home.studio.titleSasha")}
              </span>
              <br /> {t("home.studio.titleLine2")}
              <br /> {t("home.studio.titleLine3")}
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-6 md:mt-8 text-[15px] md:text-[16px] text-ink-500 leading-relaxed max-w-lg">
              {t("home.studio.paragraph")}
            </p>
            <Link
              to="/studio"
              className="mt-6 md:mt-8 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.24em] uppercase text-ink-900 underline-grow"
              data-testid="studio-link"
            >
              {t("common.conosciStudio")} <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 gap-4 md:gap-8">
          {FOUNDERS.map((p, i) => (
            <Reveal
              key={p.name}
              delay={i * 100}
              className={`relative overflow-hidden card-flat aspect-[4/5] ${
                i === 0 ? "translate-y-6 md:translate-y-8" : ""
              }`}
              data-testid={`home-team-${p.name.toLowerCase()}`}
            >
              <img
                src={p.img}
                alt={p.name}
                loading="lazy"
                className="w-full h-full object-cover img-mono"
              />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5 flex items-end justify-between">
                <div>
                  <div className="font-display text-lg md:text-xl">{p.name}</div>
                  <div className="overline text-[9px] mt-1">
                    {t("home.studio.role")}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
